import styled from '@emotion/styled';
import { useEffect, useState } from 'react';

const Timer = ({
  initialTime,
  onTimeout,
  className,
  isPaused = false,
}: {
  initialTime: number;
  onTimeout: () => void | Promise<void>;
  className?: string;
  isPaused?: boolean;
}) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isRunning, setIsRunning] = useState(true);

  useEffect(() => {
    let timerId: NodeJS.Timeout | null = null;

    if (isRunning && !isPaused) {
      timerId = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timerId);
            setIsRunning(false);
            onTimeout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [isRunning, isPaused, onTimeout]);

  if (!isRunning) {
    return <></>;
  }

  return <StyledTimer className={className}>{timeLeft}</StyledTimer>;
};

const StyledTimer = styled.div`
  position: fixed;
  top: 10px;
  right: 20px;
  ${({ theme }) => theme.typography.BOLD_36};
  color: ${({ theme }) => theme.color[2]};
`;

export default Timer;
